import Component from './Component';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

const a = new RegExp(`/${window.location.host}/`);



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Main extends Component {

    decorator () {
        return {
            selector : '.js-main',
            name : 'Main',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        // Toggle Element
        this.toggleElement();

        // Open external pages in new tab
        this.outBoundLinks();
    }


    cacheElements () {
        this.$toggleElement = Array.from(document.querySelectorAll('.js-toggle'));
        this.$links = Array.from(document.getElementsByTagName('a'));
    }


    //
    toggleElement () {
        this.$toggleElement.forEach((item, idx) => {
            let _elm = item.querySelector('.js-toggle-element');
            let _parent = _elm.closest('.js-toggle');

            _elm.addEventListener('click', e => {
                if (!_parent.classList.contains('is-active')) {
                    _parent.classList.add('is-active');
                } else {
                    _parent.classList.remove('is-active');
                }
            });
        });
    }


    //
    outBoundLinks () {
        this.$links.forEach(item => {
            const href = item.href;

            // disable for javascript:; and hash anchor tags
            if (href == 'javascript:;' || href == '#') {
                return false;
            }

            if (!a.test(item.href)) {
                item.setAttribute('target', '_blank');
            }
        });
    }
}
